import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactEcharts from 'echarts-for-react';
import { getEsgChart } from '../charts.js';
import './EsgCharts.css';
import i18n from '../../../i18n';
// import { values } from 'core-js/fn/object';

class EsgCharts extends Component {
  render() {
    const {
      data,
    } = this.props;

    const dataFiltered = data.filter((x) => (x.esgOverallRiskMetrics !== null && x.esgOverallRiskMetrics !== 'N/A'));

    for (let d = 0; d < dataFiltered.length; d++) {
      if (!data[d].esgOverallRiskMetrics) {
        continue;
      }

      const k = [];
      const v = [];
      const riskData = data[d].esgOverallRiskMetrics[data[d].esgOverallRiskMetrics.length - 1];
      const riskDataKeys = riskData.keys;
      const riskDataValues = riskData.values;
      const riskNegligible = riskDataKeys.indexOf('riskNegligible');
      const riskLow = riskDataKeys.indexOf('riskLow');
      const riskMedium = riskDataKeys.indexOf('riskMedium');
      const riskHigh = riskDataKeys.indexOf('riskHigh');
      const riskSevere = riskDataKeys.indexOf('riskSevere');
      // specifically get keys as there's extra stuff in there (wierd stuff)
      k.push(riskDataKeys[riskNegligible]);
      v.push(riskDataValues[riskNegligible]);
      k.push(riskDataKeys[riskLow]);
      v.push(riskDataValues[riskLow]);
      k.push(riskDataKeys[riskMedium]);
      v.push(riskDataValues[riskMedium]);
      k.push(riskDataKeys[riskHigh]);
      v.push(riskDataValues[riskHigh]);
      k.push(riskDataKeys[riskSevere]);
      v.push(riskDataValues[riskSevere]);
      data[d].esgOverallRiskMetrics[data[d].esgOverallRiskMetrics.length - 1].keys = k;
      data[d].esgOverallRiskMetrics[data[d].esgOverallRiskMetrics.length - 1].values = v;
    }

    const esgOverallMetricsFiltered = data.filter((x) => (x.esgOverallRiskMetrics != null));
    let asOfDate = '';
    if (esgOverallMetricsFiltered.length > 0) {
      asOfDate = new Date(esgOverallMetricsFiltered[esgOverallMetricsFiltered.length - 1].esgOverallRiskMetrics[esgOverallMetricsFiltered[esgOverallMetricsFiltered.length - 1].esgOverallRiskMetrics.length - 1].date).toLocaleDateString();
    }
    return (
      <div>
        {
          esgOverallMetricsFiltered.length > 0
          && (
            <div>
              <div className="chartHeader">
                {i18n.t('RISK RATING DISTRIBUTION')}
                {' '}
                {i18n.t('as of ')}
                {asOfDate}
                &nbsp;&nbsp;&nbsp;
              </div>
              <div className="chartContainer">
                <ReactEcharts
                  option={getEsgChart(esgOverallMetricsFiltered)}
                  theme="default"
                  style={{ height: 400 }}
                />
              </div>
            </div>
          )
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    data: state.fundData.data,

  };
}

export default connect(
  mapStateToProps,
  {
  },
)(EsgCharts);
